export const XSS = 480;
export const XS = 600;
export const SM = 800;
export const MD = 960;
export const LG = 1025;

export const MEDIA_MIN_XSS = `@media (min-width: ${XSS}px)`;
export const MEDIA_MAX_XSS = `@media (max-width: ${XSS - 1}px)`;
export const MEDIA_MIN_XS = `@media (min-width: ${XS}px)`;
export const MEDIA_MAX_XS = `@media (max-width: ${XS - 1}px)`;
export const MEDIA_MIN_SM = `@media (min-width: ${SM}px)`;
export const MEDIA_MAX_SM = `@media (max-width: ${SM - 1}px)`;
export const MEDIA_MIN_MD = `@media (min-width: ${MD}px)`;
export const MEDIA_MAX_MD = `@media (max-width: ${MD - 1}px)`;
export const MEDIA_MIN_LG = `@media (min-width: ${LG}px)`;
export const MEDIA_MAX_LG = `@media (max-width: ${LG - 1}px)`;
